import React, { useCallback, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { statusFormatterWithMap, textFormatter } from "components/Common/formatter";
import { Divider, Modal, Spin, Typography } from "antd";
import { retrieveAssetPhotos } from "utils/api";
import { defaultNgiErrorMethod } from "components/Common/responses/message";
import { Box } from "@mui/material";
import { getStatus, STATUS_COLOR_MAP } from "pages/operations/taskDetails/constants";
import CustomLink from "components/Common/buttons/CustomLink";

const useStyles = makeStyles({
  root: {},
  titleWithDescription: {
    display: "flex",
    flexDirection: "column",
    textAlign: "left",
    fontWeight: 400,

    "&>span": {
      fontSize: 13,
      fontWeight: 300,
      color: "#8C8C8C",
    },
  },
  imgPreview: {
    width: "100%",
    maxHeight: "70vh",
    objectFit: "contain",
  },
  img: {
    marginRight: 5,
    marginBottom: 5,
    "& img": {
      height: 60,
      borderRadius: 6,
      cursor: "pointer",
    },
  },
  rowImgs: {},
  images: {
    display: "flex",
    flexWrap: "wrap",
  },
  link: {
    color: "rgba(0, 133, 255, 1) !important",

    "&:hover": {
      textDecoration: "underline!important",
    },
  },
  tableContainer: {
    borderRadius: 2,
    padding: 2,
    width: "100%",
  },
  tableHeader: {
    display: "grid",
    gridTemplateColumns: "2fr 1fr 1fr 1.5fr",
    padding: 12,
    fontWeight: 400,
    fontSize: 12,
    color: "#777777",
  },
  tableRow: {
    display: "grid",
    gridTemplateColumns: "2fr 1fr 1fr 1.5fr",
    padding: 12,
    alignItems: "center",
  },
  dataContainer: {
    border: "1px solid #0000001A",
    borderRadius: 5,
  },
});

const AssetsTab = ({ task }) => {
  const classes = useStyles();
  const { completionData: { assets = [] } = {} } = task;
  const [previewUrl, setPreviewUrl] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const onPreviewImg = useCallback(id => {
    setIsOpen(true);
    retrieveAssetPhotos(null, id)
      .then(res => {
        if (res.data.result) {
          setPreviewUrl(res.data.result[0].url);
        } else {
          onClose();
        }
      })
      .catch(err => {
        defaultNgiErrorMethod(err);
        setIsOpen(false);
      });
  }, []);

  const onClose = useCallback(() => {
    setPreviewUrl("");
    setIsOpen(false);
  }, []);

  return (
    <div className={classes.root}>
      <div className={classes.titleWithDescription}>
        Collected Assets
        <span>Outcome of assets collected for the current task.</span>
      </div>
      <Divider />

      <Box className={classes.tableContainer}>
        <Box className={classes.tableHeader}>
          <div>Asset ID</div>
          <div>Asset Type</div>
          <div>Status</div>
          <div>Additional Data</div>
        </Box>

        <Box className={classes.dataContainer}>
          {assets?.map(row => (
            <Box key={row.type} className={classes.tableRow}>
              <Typography>
                <CustomLink className={classes.link} target="_blank" to={`/warehouse/assets/${row.id}`}>
                  {row.displayId}
                </CustomLink>
              </Typography>
              <Typography>{textFormatter(row.typeGroup)}</Typography>
              <Typography>
                {statusFormatterWithMap(
                  getStatus(row.status, row.isPaid),
                  STATUS_COLOR_MAP,
                  { padding: 0, fontSize: "14px" },
                  false
                )}
              </Typography>
              <Typography>
                {row.isPaid ? `Paid Amount: ${row.paidAmount}` : ""}
                {row?.photos?.length
                  ? row.photos.map((id, index) => (
                      <>
                        <CustomLink underlined key={id} color="#0085FF" onClick={() => onPreviewImg(id)}>
                          {`Photo ${index + 1} `}
                        </CustomLink>
                        <br />
                      </>
                    ))
                  : ""}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>

      {isOpen && (
        <Modal title="Photo preview" open={isOpen} onCancel={onClose} footer={[]}>
          <Spin spinning={!previewUrl}>
            {previewUrl && <img className={classes.imgPreview} src={previewUrl} alt="preview" />}
          </Spin>
        </Modal>
      )}
    </div>
  );
};

export default AssetsTab;
